export const BASE_GUTTER = 5

export const BREAKPOINT = {
  MOBILE_S: 0, // min-width should be 375px
  TABLET: 768,
  DESKTOP: 1150
}

// This is a value between 1 and 15 that will be multiplied by the BASE_GUTTER
// to obtain the correct gutter
export const DEFAULT_SPACING = {
  mobile: 4, // will result in a 20px gutter between columns
  tablet: 6, // will result in a 30px gutter between columns
  desktop: 10 // will result in a 50px gutter between columns
}

export const STORYBOOK_VIEWPORTS = {
  'mobile-375px': {
    /**
     * name to display in the dropdown
     * @type {String}
     */
    name: 'Mobile @ 375px',

    /**
     * Inline styles to be applied to the story (iframe).
     * styles is an object whose key is the camelCased version of the style name, and whose
     * value is the style’s value, usually a string
     * @type {Object}
     */
    styles: {
      overflow: 'hidden',
      width: '375px', // mobile is always 100% so there's no point in adding more space
      height: '100%'
    },

    /**
     * type of the device (e.g. desktop, mobile, or tablet)
     * @type {String}
     */
    type: 'mobile'
  },
  'tablet-768px': {
    name: 'Tablet @ 768px',
    styles: {
      overflow: 'hidden',
      width: '900px', // adding more space so the max-width is more obvious
      height: '100%'
    },
    type: 'tablet'
  },
  'desktop-1150px': {
    name: 'Desktop @ 1150px',
    styles: {
      overflow: 'hidden',
      width: '1350px', // adding more space so the max-width is more obvious
      height: '100%'
    },
    type: 'desktop'
  }
}
